import React from 'react';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import ManualTextForm from '../../../MtUmet/components/manual-text-form/ManualTextForm';

const ADD_SUBWORKFLOW_WIDTH = '800px';

const TestingModal = ({ isOpen, onSuccess, onCancel, workflowId, sourceLocale, targetLocale, live }) => {
  return (
    <Modal
      title={`Testing ${sourceLocale}:${targetLocale}`}
      open={isOpen}
      scrollContainer="modal"
      closeLabel="Close"
      width={ADD_SUBWORKFLOW_WIDTH}
    >
      <div className="minh-300">
        <ManualTextForm
          workflowId={workflowId}
          disableWorkflowSelection
          live={live}
          sourceLocale={sourceLocale}
          targetLocale={targetLocale}
          simpleForm
          onTestSuccessful={onSuccess}
        />
      </div>
      <ModalFooter>
        <Row alignmentHorizontal="right" widths="fit">
          <Button type="primary" size="small" onClick={onCancel}>
            Close
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default TestingModal;
